module.exports = __webpack_public_path__ + "img/KSC03452.b0f581e1.jpg";